module.exports = __webpack_public_path__ + "static/media/playlist-large.59edcb79.svg";